<template>
    <div>
        <Boyo-Dialog :dialogInfo="dialogInfoData"
                    @dialogEvent="dialogEventData">
            <div style="display: flex; flex-direction: row; align-items: flex-start;">
              <!-- 左侧竖向步骤条 -->
              <div style="width: 220px; min-width: 240px; margin-right: 24px;">
                <el-steps direction="vertical" :active="activeValue" class="custom-steps-vertical">
                  <el-step v-for="(itemf, index) of activeList"
                          :key="index" :title="itemf.processNodeName" :status="itemf.stepStatus || 'process'">
                    <template slot="description">
                      <div v-if="itemf.processNodeName === '制单人'">
                        {{ itemf.approvalTime }}
                      </div>
                      <div v-else>
                        <div style="border-top: 1px solid #e4e7ed; margin: 8px 0;"></div>
                        <div>流程节点：{{ itemf.processNodeName || '' }}</div>
                        <div>经办人：{{ itemf.maker || '' }}</div>
                        <div v-if="itemf.stepStatus !== 'process'">备注：{{ itemf.remark || (itemf.stepStatus === 'success' ? '通过' : '拒绝') }}</div>
                        <div>时间：{{ itemf.makerTime || '' }}</div>
                      </div>
                    </template>
                  </el-step>
                </el-steps>
              </div>
              <!-- 右侧内容 -->
              <div style="flex: 1; overflow-x: auto;">
                <Boyo-Formtwo :formInfo="formInfo2"
                        :refObj.sync="formInfo2.ref"
                        :listTypeInfo='listTypeInfo'
                        @handlePictureCardPreview="handlePictureCardPreview">
                </Boyo-Formtwo>
                <el-table :data="tableData"
                        border
                        :summary-method="getSummaries"
                        show-summary
                        max-height="430"
                        style="width: 99%;margin-top:12px;margin-bottom:12px"
                        :header-cell-style="{background:'rgb(189,215,252)',color:'#3C3C3C',padding:'4px 0'}"
                        :cell-style="{padding:'2px'}">
                  <el-table-column fixed="left"
                      type="index"
                      width="50">
                    </el-table-column>
                  <el-table-column prop="carNo"
                                  align="center"
                                  label="车号" width='80px'>
                  </el-table-column>
                  <el-table-column prop="driver"
                                  align="center"
                                  label="司机" width='90px'>
                  </el-table-column>
                  <el-table-column prop="materialNo" align="center" width="90px"
                                  label="物料编号">
                  </el-table-column>
                  <el-table-column prop="materialName"
                                  label="物料名称"
                                  align="center"
                                  width="200px">
                  </el-table-column>
                  <el-table-column prop="materialSpec" align="center" width="100px"
                                  label="物料规格">
                  </el-table-column>
                  <el-table-column prop="quantity"
                                  align="center"
                                  label="数量" width="90px">
                  </el-table-column>
                  <el-table-column prop="unit"
                                  align="center"
                                  label="单位" width='90px'>
                  </el-table-column>
                  <el-table-column prop="remark"
                                  align="center"
                                  label="备注">
                  </el-table-column>
                </el-table>
                <!-- 审核表单 -->
                <div v-if="showAuditDataFields" style="margin-top: 20px; border-top: 1px solid #ebeef5; padding-top: 20px;">
        <!-- 添加快捷短语区域 -->
        <div class="quick-phrase-area">
          <div class="quick-phrase-label">常用快捷短语:</div>
          <div class="quick-phrase-buttons">
            <el-button 
                v-for="(phrase, index) in quickPhrases" 
                :key="index"
                size="mini"
                @click="insertQuickPhrase(phrase)"
                class="phrase-btn">
                {{ phrase }}
            </el-button>
          </div>
        </div>
                  <Boyo-Formtwo :formInfo="formInfoAuditData"
                             :refObj.sync="formInfoAuditData.ref"
                             :listTypeInfo="listTypeInfo">
                  </Boyo-Formtwo>
                </div>
              </div>
            </div>
        </Boyo-Dialog>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="pingImgUrl+dialogImageUrl" alt="">
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible2" class="imgDialog">
            <img width="100%" :src="dialogImageUrl2" alt="">
        </el-dialog>
    </div>
</template>

<script>
import BoyoFilter from '@/components/BoyoFilter'
import BoyoContent from '@/components/BoyoContent'
import BoyoButton from '@/components/BoyoButton'
import BoyoTable from '@/components/BoyoTable'
import BoyoDialog from '@/components/BoyoDialog'
import BoyoForm from '@/components/BoyoForm'
import BoyoFormtwo from '@/components/BoyoFormtwo'
import config from '@/api/config'
export default {
  name: 'ApplicationFormDialog',
  components: {
    BoyoFilter,
    BoyoContent,
    BoyoButton,
    BoyoTable,
    BoyoDialog,
    BoyoForm,BoyoFormtwo
  },
  props: {},
  data () {
    return {
      activeValue:null,
      activeList:[],
      search: {},
      tableData:[],
      detailDate:{},
      billId:'',
      dataId:'',
      add2:0,
      dialogVisible:false,
      dialogImageUrl:'',
      dialogImageUrl2: '',
      dialogVisible2: false,
      quickPhrases: [
            '同意',
            '不同意',
            '需要补充相关附件',
            '申请表'
        ],
        showPhraseManager: false,
        newPhrase: '',
      pingImgUrl: config.pingImgUrl,
      amountUnit:localStorage.amountUnit,
      auditParm:{},
      // 下拉框相关信息
      listTypeInfo: {
        purMode :[],
        statusFlag2:[{value:1,label:'同意'},{value:2,label:'不同意'}],
        processId: [], // 新增流程枚举
      },
      formInfo2: {
        ref: null,
        labelWidth: "112px",
        inline: true,
        data: {
          id: null,
          code:'',
          projectName:'',
          contractNumber:'',
          constructionId:'',
          constructionUnit:'',
          materialOwnershipId:'',
          materialOwnershipUnit:'',
          applicantDescribe:'',
          applicant:'',
          employeeId:'',
          applicantPhone:'',
          applicantDate:'',
          applicationFile:'',
          approvalFile:'',
        },
        list: [
          {type: "text",label: "编号：",value: "code", style: 'width:95%', className: 'form_item_two',disabled:true},
            {type: "text",label: "项目名称：",value: "projectName", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "text",label: "合同编号：",value: "contractNumber",labelContent:'合同编号/维修单编号', style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "text",label: "所属单位：",value: "materialOwnershipUnit",labelContent:'材料所属单位', style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "text",label: "施工单位：",value: "constructionUnit",labelContent:'供应商/施工单位', style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "text",label: "申请人：",value: "applicant", style: 'width:95%', className: 'form_item_two',unclearable:true,disabled:true},
          {type: "text",label: "联系方式：",value: "applicantPhone",labelContent:'申请人联系方式', style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "date",label: "申请时间：",value: "applicantDate", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "textarea",label: "申请说明：",value: "applicantDescribe", style: 'width:95%', className: 'form_item_two',disabled:true},
          { type: 'uploadThree', label: '申请表文件：', value: 'applicationFile', style: 'width:95%;', className: 'form_item_two',fileListHt:[],disabled:true},
            { type: 'uploadThree', label: '审批单文件：', value: 'approvalFile', style: 'width:95%;', className: 'form_item_one',fileListHt:[] ,disabled:true},
        ],
        rules: {}
      },
      createdBy: null, // 保存传入的制单人
      createdTime: null, // 保存传入的制单时间
      showAuditDataFields: false, // 是否显示审核表单
      formInfoAuditData: {
        ref: null,
        labelWidth: '100px',
        data: {
          id:'',
          processId:'',
          remark:'',
          status:'',
        },
        list: [
          { type: 'select流程名称：', label: '流程名称：', value: 'processId', list: 'processId', style: 'width:80%',disabled:true},
          { type: 'selectRadio', label: '审核：', value: 'status', style: 'width:95%', className: 'form_item_one',list:'statusFlag2',unclearable:true},
          { type: 'text', label: '备注：', value: 'remark', style: 'width:80%'},
        ],
        rules: {
          status:[{ required: true, trigger: 'change',message: '请选择' }]
        }
      },
        dialogInfoData: {
            visible: false, // 弹框是否显示
            width: '1200px', // 宽度
            title: {
                add: '申请表对应数据', // 标题
            },
            type: 'add', // 显示哪个标题
            // 按钮列表
            btList: [
                { label: '审核', type: 'success', icon: '', event: 'save', loading: false ,show:false},
                { label: '关闭', type: '', icon: '', event: 'close', loading: false }
            ]
        },
    }
  },
  created () {
  },
  mounted () {
    this.$api.dictionary.getSysEnumPage({pageNum: 1, pageSize: 999,enumCategoryCode:'PurMode'}).then(res => {
        if(res.code == 0) {
            let list1 = res.data.list
            for( let i in list1 ) {
                this.listTypeInfo.purMode.push({value: Number(list1[i].enumName), label: list1[i].enumValue})
            }
        }
    })
  },
  methods: {
    dialogShow(data, val, parm, id, maker, makerTime){
        this.billId = data
        this.dataId = id
        // 保存传入的制单人和时间
        this.createdBy = maker
        this.createdTime = makerTime
        if(parm && parm.id){
          this.auditParm = parm
          this.dialogInfoData.btList[0].show = true
          this.showAuditDataFields = true
          // 初始化审核表单数据
          this.$nextTick(() => {
            for (const key in this.formInfoAuditData.data) {
              this.formInfoAuditData.data[key] = ''
            }
            // 查找并设置流程名称
            const loadProcessEnum = () => {
              return new Promise((resolve) => {
                if (this.listTypeInfo.processId && this.listTypeInfo.processId.length > 0) {
                  resolve();
                } else {
                  this.$api.ThirdPartyInterface.getActProcessConfigPage({pageNum: 1, pageSize: 999,carTypeArray:[2,3], status:1}).then(res => {
                    if(res.code == 0) {
                      let list1 = res.data.list
                      for(let i in list1) {
                        this.listTypeInfo.processId.push({value: list1[i].processId, enumValue: list1[i].processCode, label: list1[i].name})
                      }
                      resolve();
                    } else {
                      this.$message({ message: '加载流程枚举失败: ' + res.msg, type: 'error' })
                      resolve();
                    }
                  }).catch(() => {
                    resolve();
                  });
                }
              });
            };
            // 加载流程枚举后再设置流程名称
            loadProcessEnum().then(() => {
              let processFound = false;
              for (let inde of this.listTypeInfo.processId) {
                if (parm.processId == inde.enumValue) {
                  this.formInfoAuditData.data.processId = inde.value
                  processFound = true;
                  break;
                }
              }
              // 如果没找到匹配的流程，记录日志并设置一个默认值
              if (!processFound) {
                this.formInfoAuditData.data.processId = parm.processId;
              }
              this.formInfoAuditData.data.status = 1
            });
          })
        }else{
          this.dialogInfoData.btList[0].show = false
          this.showAuditDataFields = false
        }
        this.getInfo(val)
    },
    formatAmount(cellValue) {
      if (typeof cellValue == 'number') {
        cellValue = Number(cellValue.toFixed(2))
        return cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }else{
          return cellValue
      }
    },
    // 搜索事件
    getInfo (val) {
      this.$api.system.getActProcessEntryPage({idProcessInstance:this.dataId,pageNum:1,pageSize:999}).then(res => {
          if (res.code == 0) {
              this.activeList = []
              this.activeValue = 0
              for (let i in res.data.list) {
                  if(res.data.list[i].status && i < res.data.list.length){
                      this.activeValue = Number(Number(i) + 1)
                  }
                  this.activeList.push({
                    processNodeName: res.data.list[i].processNodeName || '', // 第一行：流程节点名称
                    maker: res.data.list[i].status
                      ? res.data.list[i].actualApprover
                      : (res.data.list[i].approver ? res.data.list[i].approver : res.data.list[i].roleName), // 第二行：经办人
                    remark: res.data.list[i].remark || '', // 第三行：备注
                    makerTime: res.data.list[i].approvalTime || '', // 第四行：时间
                    stepStatus: res.data.list[i].status ? 'success' : 'process'
                  })
              }
               // 始终在最前面插入"制单人"节点
              let maker = this.createdBy || (val && val.createBy ? val.createBy : '暂无');
              let makerTime = this.createdTime || (val && val.createTime ? val.createTime : '');
              let approvalTime = maker + (makerTime ? (' ' + makerTime) : '');
              this.activeList.unshift({ processNodeName: '制单人', approvalTime });
              this.activeValue = (this.activeValue || 0) + 1;
          }else{
              this.$message({ message: res.msg, type: "error" });
          }
      })
      this.$api.OrderPurchase.getStkApplicationPage({id:this.billId,pageNum:1,pageSize:0}).then(
        res => {
          if (res.code == 0) {
            if(res.data.list.length > 0){
                this.detailDate = res.data.list[0]
                for (let key in this.formInfo2.data) {
                  this.formInfo2.data[key] = ''
                }
                for (let key in this.detailDate) {
                  if (key in this.formInfo2.data) {
                    this.formInfo2.data[key] = this.detailDate[key];
                  }
                }
                if (this.formInfo2.list[this.formInfo2.list.length - 1]) {
                  this.formInfo2.list[this.formInfo2.list.length - 1].fileListHt = []
                  if (this.detailDate.approvalFile) {
                    this.formInfo2.list[this.formInfo2.list.length - 1].fileListHt = [{name: (this.detailDate.approvalFile.split('-').length > 2)?this.detailDate.approvalFile.split('-')[2]:this.detailDate.approvalFile.split('-')[1],url: this.detailDate.approvalFile}]
                  }
                }
                if (this.formInfo2.list[this.formInfo2.list.length - 2]) {
                  this.formInfo2.list[this.formInfo2.list.length - 2].fileListHt = []
                  if (this.detailDate.applicationFile) {
                    this.formInfo2.list[this.formInfo2.list.length - 2].fileListHt = [{name: (this.detailDate.applicationFile.split('-').length > 2)?this.detailDate.applicationFile.split('-')[2]:this.detailDate.applicationFile.split('-')[1],url: this.detailDate.applicationFile}]
                  }
                }
                this.$api.OrderPurchase.getStkApplicationEntryPage({idApplication:this.detailDate.id,pageNum:1,pageSize:999}).then(res => {
                  if (res.code == 0) {
                    this.tableData = res.data.list
                  }else{
                    this.$message({ message: res.msg, type: "error" });
                  }
                })
                if(!val){
                  this.dialogInfoData.visible = true
                }
            } else {
                this.$message({ message: '对应数据查找为空', type: 'warning' })
            }
          }else{
            this.$message({ message: res.msg, type: "error" });
          }
        },
        err => {
          console.log(err)
          this.content.loading = false
        }
      )
    },
    dialogEventData(event){
        const dialogInfoData = this.dialogInfoData
        switch (event) {
            case 'save':
              this.formInfoAuditData.ref.validate(valid => {
                if (valid) {
                  let parma = {
                    id: this.auditParm.id,
                    processId: this.formInfoAuditData.data.processId,
                    status: this.formInfoAuditData.data.status,
                    remark: this.formInfoAuditData.data.remark
                  }
                  dialogInfoData.btList[0].loading = true
                  this.$api.system.approval(parma).then(res => {
                    dialogInfoData.btList[0].loading = false
                    if (res.code === 0) {
                      this.$message({ message: res.msg, type: 'success' })
                      dialogInfoData.visible = false
                      this.showAuditDataFields = false
                      this.$emit('approvalInfo')
                    } else {
                      this.$message({ message: res.msg, type: 'error' })
                    }
                  }).catch(() => {
                    dialogInfoData.btList[0].loading = false
                  })
                }
              })
              break
            case 'close':
                dialogInfoData.visible = false
                this.showAuditDataFields = false
                break
        }
    },
    // 表单内部事件
    formClick (event) {
      switch (event) {
      }
    },
    getSummaries (param) {
      //param 是固定的对象，里面包含 columns与 data参数的对象 {columns: Array[4], data: Array[5]},包含了表格的所有的列与数据信息
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '小计';
          return;
        }
        for(let i=0; i<100;i++){
          if(sums[i]==0){
            sums[i]=''
          }
        }
        const values = data.map(item => Number(item[column.property]));
        if (column.property === 'baseQuantity'|| column.property === 'purMoney' || column.property === 'purExctTaxMoney' || column.property === 'carNetWeight' || column.property === 'carDeductWeight' || column.property === 'settleQuantity' || column.property === 'settleExctTaxAmount' || column.property === 'settleAmount') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index]?this.formatAmount(Number(sums[index].toFixed(3))):'';
        }
      });
      this.$emit('getSummaries', sums)
      return sums;
    },
    previewAvatar(file) { // 查看文件
      window.open(config.pingImgUrl + file.url)
    },
    handlePictureCardPreview (url, value) {
      if(url){
        this.dialogVisible2 = true
        this.dialogImageUrl2 = url
      }
    },
    insertQuickPhrase(phrase) {
        // 获取当前备注值
        const currentRemark = this.formInfoAuditData.data.remark || '';
        
        // 插入短语到备注中
        if (currentRemark) {
            this.formInfoAuditData.data.remark = currentRemark + ' ' + phrase;
        } else {
            this.formInfoAuditData.data.remark = phrase;
        }
    },
    addNewPhrase() {
        if (this.newPhrase.trim()) {
            this.quickPhrases.push(this.newPhrase.trim());
            this.newPhrase = '';
        }
    },
    removePhrase(index) {
        this.quickPhrases.splice(index, 1);
    },
  }
}
</script>
<style lang="stylus" scoped>
.quick-phrase-area {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px dashed #dcdfe6;
}

.quick-phrase-label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #606266;
}

.quick-phrase-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.phrase-btn {
  margin: 0;
  white-space: nowrap;
}

.phrase-manager-btn {
  margin: 0;
}

.phrase-manager {
  max-height: 400px;
  overflow-y: auto;
}

.phrase-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.phrase-input {
  flex: 1;
  margin-right: 10px;
}

.phrase-delete-btn {
  flex-shrink: 0;
}

.phrase-add {
  display: flex;
  margin-top: 15px;
}

.phrase-add-input {
  flex: 1;
  margin-right: 10px;
}

.phrase-add-btn {
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Custom/ApplicationFormDialog.vue